/**
 * Created by bxtang on 2017/3/21.
 */
import React from "react"
import {
  Input, TimePicker, Select, Form, Checkbox,
} from "antd"

const FormItem = Form.Item;
const Option = Select.Option;
const itemLayout = {
  labelCol: { span: 2},
  wrapperCol: { span: 8 },
};
const itemLayoutLabel = {
  wrapperCol: { span: 12, offset:2},
};
class DirectiveItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      directiveList: [],
      beanList:[]
    }
    this.setBeanList = this.setBeanList.bind(this)
  }

  componentDidMount() {
    if (this.props.directiveList) {
      let beanList = this.props.directiveList.map(function (item) {
        let obj = {}
        if (item.type == "select") {
          const optionList = eval(item.value);
          let selectDefaultValue;
          const options = optionList.map(function (v, index2) {
            if (index2 == 0) {
              selectDefaultValue = v.value.toString();
            }
          })
          obj.selectValue = selectDefaultValue
        }
        return obj
      })
      this.setState({
        directiveList: this.props.directiveList,
        beanList:beanList
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.directiveList)
    if (nextProps.directiveList != this.props.directiveList) {
      this.forceUpdate();
      let beanList = nextProps.directiveList.map(function (item) {
        let obj = {}
        if (item.type == "select") {
          const optionList = eval(item.value);
          let selectDefaultValue;
          const options = optionList.map(function (v, index2) {
            if (index2 == 0) {
              selectDefaultValue = v.value.toString();
            }
          })
          obj.selectValue = selectDefaultValue
        }
        return obj
      })
      this.setState({
        directiveList: nextProps.directiveList,
        beanList:beanList
      })
    }
  }

  setBeanList(index,obj) {
    const {beanList} = this.state;
    let newBeanList = JSON.parse(JSON.stringify(beanList))
    newBeanList[index]= obj;
    console.log(newBeanList)
    this.setState({
      beanList:newBeanList
    })
  }

  render() {
    let that = this;
    const timeItems = this.props.directiveList.map(function (item, index) {
      let directiveItem;
      if (item.type == "hourAndMin" || item.type == "hour:min") {
        directiveItem = <div>
          <FormItem
              key={index}
              label={item.key}
              {...itemLayout}
              name={`param.beanList[${index}].timeValue`}
              style={{ marginTop: 10,marginBottom: 0 }}
          >
              <TimePicker format="HH:mm"  onChange={(value)=>{
                if(value){
                  let obj = {}
                  obj['timeValue'] = value;
                  obj['type'] = item.type;
                  that.setBeanList(index,obj)
                }else {
                  let obj = {}
                  obj['timeValue'] = '';
                  obj['type'] = item.type;
                  that.setBeanList(index,obj)
                }

              }}/>
          </FormItem>
        </div>
      } else if (item.type == "select") {
        const optionList = eval(item.value);
        let selectDefaultValue;
        const options = optionList.map(function (v, index2) {
          if (index2 == 0) {
            selectDefaultValue = v.value.toString();
          }
          return (
            <Option
                key={index2}
                value={v.value.toString()}
            >
              {v.key}
            </Option>
          )
        })
        directiveItem = (
          <FormItem
              key={index}
              label={item.key}
              {...itemLayout}
              name={`param.beanList[${index}].selectValue`}
              style={{ marginTop: 10,marginBottom: 0 }}
          >
            <Select
                defaultValue={selectDefaultValue}
                style={{ width: 200 }}
                onChange={(value)=>{
                  let obj = {}
                  obj['selectValue'] = value;
                  that.setBeanList(index,obj)
                }}
            >
              {options}
            </Select>
          </FormItem>
        )
      } else if (item.type == "string" || item.type == "mobile") {
        directiveItem = (
          <FormItem
              key={index}
              label={item.key}
              {...itemLayout}
              name={`param.beanList[${index}].inputValue`}
              style={{ marginTop: 10,marginBottom: item.type == "mobile" ?15 :0}}
          >
            <Input style={{ width: 200 }} type="text" autoComplete='new-password'  onChange={(e)=>{
              console.log(e.target.value)
              let obj = {}
              obj['inputValue'] = e.target.value;
              that.setBeanList(index,obj)
            }} />
          </FormItem>
        )
      } else if (item.type == "checkbox") {
        directiveItem = <div>
          <FormItem
              key={index}
              label={item.key}
              name={`param.beanList[${index}].checkedValue`}
              {...itemLayout}
              style={{ marginTop: 10,marginBottom: 0 }}
          >
            <Checkbox defaultChecked={false} onChange={(e)=>{
              console.log(e.target.value)
              let obj = {}
              obj['checkedValue'] = e.target.checked;
              obj['formatValue'] = item.value;
              that.setBeanList(index,obj)
            }}  />
          </FormItem>
        </div>
      } else if (item.type == "int") {
        directiveItem = (
          <FormItem
              key={index}
              label={item.key}
              {...itemLayout}
              name={`param.beanList[${index}].intValue`}
              style={{ marginTop: 10,marginBottom: 0 }}
          >
          <Input style={{ width: 200 }} type="text" autoComplete='new-password' onChange={(e)=>{
            console.log(e.target.value)
            let obj = {}
            obj['intValue'] = e.target.value;
            that.setBeanList(index,obj)
          }}/>
          </FormItem>
        )
      }
      let desc;
      if (item.desc) {
        desc = (
          <FormItem
              label={null}
              {...itemLayoutLabel}
              style={{marginBottom: 0 }}
          >
            <span style={{color:'#888888'}}>{item.desc}</span>
          </FormItem>
        )
      }
      return (
        <div key={index}>
          {directiveItem}
          {desc}
        </div>
      )
    });
    return (
      <div>
        {timeItems}
      </div>
    );
  }
}
export default DirectiveItems
